import { Button } from "antd";
import "./OnlineMenus.scss";
import { ScissorOutlined } from "@ant-design/icons";
import { useRecoilValue } from "recoil";
import { memberState } from "../../state/atoms";
import OrderingMenuIcon from "../icons/OrderingMenuIcon";
import { synchronousRequest } from "../../util/utils";
import { isTestEnv } from "../../util/constants";
import { LocationDto } from "../../generated/dashboard-client/api";
import { env } from "../../env/env";
import { isDesignSubscription } from "../../service/BillingService";

interface OnlineMenusProps {
  activeLocation: LocationDto;
}

export default function OnlineMenus({activeLocation}: OnlineMenusProps) {
  const member = useRecoilValue(memberState);

  function goPro() {
    const onSuccess = () => {
      setTimeout(() => {
        const resp = synchronousRequest(`/app/online/location/stats/${activeLocation.internalId!}?oo=true`);
        //let location: any | null = null;
        if (resp) {
          try {
            //location = JSON.parse(JSON.parse(resp).data).location;
          } catch (e) {
            console.error(e);
          }
        }

        const base = isTestEnv ? 'https://test.mhmfun.com' : 'https://ohbz.com';//window.location.href.indexOf("staging.") > -1 ? "https://www.musthavemenus.com" : env.basePath;
        const tkn = window.localStorage.getItem("tkn");
        window.open(`${base}${env.ooContextPath}?businessId=${activeLocation.internalId}&tkn=${tkn}`, '_blank');
      }, 200);

      setTimeout(() => {
        // window.location.reload();
        window.location.href = `/`;
      }, 1000);
    }

    if (isDesignSubscription(member)) {
      window.MHM.ProModal.switchToProWithOverview({ memberId: member.id, onSuccess });
    } else {
      window.MHM.ProModal.upgrade({ memberId: member.id, onSuccess });
    }
  }

  const omCircleIcon = <div className="om-circle">
    <OrderingMenuIcon fill="#fff"/>  
  </div>

  return <div className={"online-menus page"}>
    <section className="freemium-splash">
      <div className="upgrade-txt">
        <img src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="pro star" />
        <h4>Upgrade to use this feature</h4>
      </div>
      <h2 className="mobile-only">
        {omCircleIcon}
        Ordering Menus
      </h2>
      <div className="info">
        <div className="text">
          <h2 className="desktop-only">
            {omCircleIcon}
            Ordering Menus
          </h2>
          <ul>
            <li>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/StockGain.svg" alt="stock gain" />
              </div>
              <div>
                <h4>Increase in-store sales</h4>
                <p>Turn your tables quicker with a menu that can be viewed in seconds.</p>
              </div>
            </li>
            <li>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/Online.svg" alt="online" />
              </div>
              <div>
                <h4>Increase online sales</h4>
                <p>Boost takeout sales and avoid commissions with online ordering.</p>
              </div>
            </li>
            <li>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/Smile.svg" alt="online" />
              </div>
              <div>
                <h4>Better guest experience</h4>
                <p>Delight your customers with a more visual menu optimized for phones.</p>
              </div>
            </li>
            <li>
              <div>
                <ScissorOutlined />
              </div>
              <div>
                <h4>Cut costs</h4>
                <p>Make fewer table trips and update menus instantly.</p>
              </div>
            </li>
          </ul>
          <Button size={"large"} className={"primary"} onClick={goPro}>
            Get Pro to use Ordering Menus!
          </Button>
        </div>
        <div className="img">
          <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OMFreemiumSplashHero.webp" alt="lp freemium hero" />
        </div>
      </div>

      <div className="examples">
        <h3>More amazing customer examples</h3>
        <ul>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_78624.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_AberrantAles.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_BistroAtAnnies.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_CucinaBella.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_EndlessDreamers.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_HamburgerMarys.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_Hops44.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_JadeSushi.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_LaBuonaPizza.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_LaPiedBleu.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_OnTheDunes.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_PublicHouseonPageHill.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_RanchoCapistrano.webp" alt="om" />
          </li>
          <li>
            <img src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/OMSplash/OM_Risotto.webp" alt="om" />
          </li>
        </ul>
      </div>
    </section>
  </div>;
}
